(function() {
  if (window.GlobalToast) {
    return;
  }

  var toastRoot = document.querySelector('[data-global-toast]');
  if (!toastRoot) {
    console.warn('[GlobalToast] Missing toast container. Include snippets/global-toast.liquid in theme.liquid.');
    return;
  }

  var messageEl = toastRoot.querySelector('[data-global-toast-message]');
  var iconEl = toastRoot.querySelector('[data-global-toast-icon]');
  var closeBtn = toastRoot.querySelector('[data-global-toast-close]');
  var hideTimeout = null;
  var defaultDuration = 3000;

  function getAssetsRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function setIcon(type) {
    if (!iconEl) return;

    var assetsRoot = getAssetsRoot();
    var iconPath = 'assets/icon-toast-success.svg';

    if (type === 'error') {
      iconPath = 'assets/icon-toast-error.svg';
    } else if (type === 'info') {
      iconPath = 'assets/icon-toast-info.svg';
    }

    iconEl.style.backgroundImage = 'url(' + assetsRoot + iconPath + ')';
    iconEl.style.display = 'inline-flex';
  }

  function hideToast() {
    toastRoot.classList.remove('global-toast--visible');
    toastRoot.setAttribute('aria-hidden', 'true');
  }

  function showToast(message, options) {
    options = options || {};
    var type = options.type || 'success';
    var duration = typeof options.duration === 'number' ? options.duration : defaultDuration;

    if (!messageEl) return;

    messageEl.textContent = message;
    setIcon(type);

    if (hideTimeout) {
      clearTimeout(hideTimeout);
    }

    toastRoot.classList.add('global-toast--visible');
    toastRoot.setAttribute('aria-hidden', 'false');

    if (duration > 0) {
      hideTimeout = setTimeout(function() {
        hideToast();
      }, duration);
    }
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      if (hideTimeout) {
        clearTimeout(hideTimeout);
      }
      hideToast();
    });
  }

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-global-toast-trigger]');
    if (!trigger) return;

    var message = trigger.getAttribute('data-toast-message');
    if (!message) return;

    var type = trigger.getAttribute('data-toast-type') || 'success';
    var durationAttr = trigger.getAttribute('data-toast-duration');
    var duration = durationAttr ? parseInt(durationAttr, 10) : undefined;

    showToast(message, { type: type, duration: duration });
  });

  window.GlobalToast = {
    show: showToast,
    hide: hideToast
  };
})();
